import { LCDocumentEditorUtils } from './LCDocumentEditorUtils';
import { EditorAttachedFilePlugin } from './EditorAttachedFilePlugin';
import { SelectionDialogs } from './../SelectionDialogs';
import { ILectioPlugin } from './Types';
import { LCDialogEditorUtils } from './LCEditorDialogUtils';
import { LectioJSUtils } from '../LectioJSUtils';

export class PluginAttachedFile implements ILectioPlugin {
	public Init(): void {
		CKEDITOR.plugins.add('attachedfile', {
			init: (editorOuter: CKEDITOR.editor) => {

				const getDialogDef = (editor: CKEDITOR.editor) => {
					let documentInfoSaved: SelectionDialogs.SelectedSerializedAnyFileId | null = null;
					let insertMode: boolean;

					function showFileChooser(closeDialogOnFileSelected: boolean) {
						SelectionDialogs.ShowChooseDocumentDialog({
							title: "Vælg fil", year: LCDocumentEditorUtils.Year,
							isPublic: false, showCheckbox: false, warnIfUploadIsOld: false
						})
							.then(documentInfo => {
								if (documentInfo == null)
									return;
								selectFile(documentInfo, closeDialogOnFileSelected);
							});
					}

					function selectFile(file: SelectionDialogs.SelectedSerializedAnyFileId, closeDialogOnFileSelected: boolean) {
						documentInfoSaved = file;
						const dialog = CKEDITOR.dialog.getCurrent();
						dialog.getContentElement('tab-basic', 'filename').setValue(file.filename);
						if (closeDialogOnFileSelected)
							dialog.getButton("ok").click();
					}

					const ddef: CKEDITOR.dialog.IDialogDefinition & { selectFile: any } = {
						title: "Vælg fil",
						minWidth: 400,
						minHeight: 150,
						selectFile: selectFile,
						contents: [
							{
								id: 'tab-basic',
								label: 'Basic settings',
								elements: [
									{
										type: 'text',
										label: 'Filnavn',
										id: 'filename',
										validate: CKEDITOR.dialog.validate.notEmpty('Der skal angives en fil.'),
										setup(element) {
											if (!(element instanceof CKEDITOR.dom.element))
												throw new Error('ikke element?');
											const resourceFilename = LCDocumentEditorUtils.TryGetResourceFilename(element.getAttribute('href') || '');
											if (!resourceFilename)
												throw new Error('Viser dialog for vedhæftet fil, men har ikke passende url?');
											this.setValue(resourceFilename);
										}
									}, {
										type: 'button',
										label: 'Vælg fil',
										id: 'fileChoose',
										align: 'right',
										onClick: (evt: any) => {
											showFileChooser(true);
										},
									}
								]
							}
						],
						onShow() {
							const dialog = this;
							const e = dialog.getContentElement('tab-basic', 'filename');
							e.disable();

							const selection = editor.getSelection()!;
							const element = selection.getStartElement();
							const a = element.getAscendant('a', true);
							if (!(a instanceof CKEDITOR.dom.element))
								throw new Error('ikke element?');
							insertMode = !a;
							if (insertMode) {
								showFileChooser(true);
								return;
							}
							const isAttachedFile = !!LCDocumentEditorUtils.TryGetResourceFilename(a.getAttribute('href') || '');
							if (!isAttachedFile)
								throw new Error('Viser dialog for vedhæftet fil, men har ikke passende url?');

							dialog.setupContent(a);
						},
						onOk: () => {
							if (!documentInfoSaved)
								return;

							EditorAttachedFilePlugin.CreateOrUpdateAttachedFileFile(editor, documentInfoSaved.serializedId, documentInfoSaved.filename, insertMode);
						}
					};
					return ddef;
				};

				//if (editorOuter.contextMenu) {
				//	editorOuter.addMenuGroup('lectioGroup');
				//	editorOuter.addMenuItem('attachedFileItem', {
				//		label: 'Vælg fil',
				//		icon: CKEDITOR.skin.icons.file.path,
				//		command: 'InsertAttachedFile',
				//		group: 'lectioGroup'
				//	});
				//	editorOuter.contextMenu.addListener((element: CKEDITOR.dom.element) => {
				//		const a = <CKEDITOR.dom.element>element.getAscendant('a', true);
				//		if (!a)
				//			return null;
				//		const isAttachedFile = !!LCDocumentEditorUtils.TryGetResourceFilename(a.getAttribute('href'));
				//		if (!isAttachedFile)
				//			return null;
				//		return { attachedFileItem: CKEDITOR.TRISTATE_OFF };
				//	});
				//}

				CKEDITOR.dialog.add('attachedFileDialog', getDialogDef);

				editorOuter.addCommand('InsertAttachedFile', {
					exec: editor => {
						const editorConfig = LCDocumentEditorUtils.GetEditorConfig(editor);
						const resp = LCDialogEditorUtils.ShowSuitableContentPicker(
							editor,
							{ folderid: SelectionDialogs.InitialFolder.uploadFile },
							editorConfig);

						resp.promise.then(selection => {
							if (!selection)
								return;

							LCDialogEditorUtils.ProcessNewHomeworkSelection(
								editor, selection,
								editorConfig.handleHomeworkPickerSelection,
								resp.editorHadFocus);

							LectioJSUtils.DispatchBrowserTestEvent('attachedfileinserted');
						});

						return true;
					}
				});
				editorOuter.addCommand('InsertAttachedFileDialog', new (CKEDITOR as any).dialogCommand('attachedFileDialog', {
					allowedContent: 'a[href]',
					requiredContent: 'a[href]'
				}));

				const cfg = LCDocumentEditorUtils.GetEditorConfig(editorOuter);

				editorOuter.ui.addButton('InsertAttachedFileButton', {
					label: "Vælg fil",
					command: 'InsertAttachedFile',
					icon: CKEDITOR.skin.icons.file!.path,
					toolbar: ''
				});
			}
		});
	}
}
